/* LOFTfifty6 — stoelconfigurator (Passe Partout).

   Wat dit bestand doet: de keuzes tekenen (uitvoering, houtkleur, stofgroep,
   stof), bijhouden wat er gekozen is, de juiste variant opzoeken en het
   formulier vullen. Meer niet.

   Wat het bewust NIET doet: prijzen uitrekenen. Elke prijs komt uit de variant
   die Shopify heeft meegegeven. Zodra hier zou worden opgeteld of afgetrokken,
   kan de pagina een ander bedrag tonen dan de winkelwagen rekent.

   Het bestellen gaat via een gewone formulierverzending naar /cart/add. Dat is
   met opzet: zo hangt de belangrijkste knop van de pagina niet af van een
   fetch-aanroep of van de winkelwagenlade van het thema. Lukt het niet, dan
   toont Shopify zelf een foutpagina in plaats van dat er stilletjes niets
   gebeurt.

   De stof is geen productoptie maar een regel-eigenschap: binnen een stofgroep
   kost elke kleur hetzelfde, dus er is geen variant per kleur. De gekozen stof
   gaat mee als properties[Stof] en properties[Stofcode]. */

(function () {
  'use strict';

  document.querySelectorAll('[data-lf-stoel]').forEach(start);

  function start(wortel) {
    var bron = wortel.querySelector('[data-lf-stoel-data]');
    if (!bron) return;

    var data;
    try {
      data = JSON.parse(bron.textContent);
    } catch (fout) {
      // Liever een lege configurator met een melding dan een halve pagina.
      console.error('lf-stoel: gegevens onleesbaar', fout);
      return;
    }
    if (!data.varianten || !data.varianten.length) return;

    var idx = data.opties || {};
    var vak = {
      hoofdbeeld: wortel.querySelector('[data-lf-hoofdbeeld]'),
      strip: wortel.querySelector('[data-lf-strip]'),
      uitvoering: wortel.querySelector('[data-lf-uitvoering]'),
      hout: wortel.querySelector('[data-lf-hout]'),
      stofgroepen: wortel.querySelector('[data-lf-stofgroepen]'),
      stoffen: wortel.querySelector('[data-lf-stoffen]'),
      stoffenLeeg: wortel.querySelector('[data-lf-stoffen-leeg]'),
      groeptoelichting: wortel.querySelector('[data-lf-groeptoelichting]'),
      stofkaart: wortel.querySelector('[data-lf-stofkaart]'),
      samenvatting: wortel.querySelector('[data-lf-samenvatting]'),
      prijs: wortel.querySelector('[data-lf-prijs]'),
      totaal: wortel.querySelector('[data-lf-totaal]'),
      mobielTotaal: wortel.querySelector('[data-lf-mobiel-totaal]'),
      mobiel: wortel.querySelector('[data-lf-mobiel]'),
      variantId: wortel.querySelector('[data-lf-variant-id]'),
      bestel: wortel.querySelector('[data-lf-bestel]'),
      melding: wortel.querySelector('[data-lf-melding]'),
      laag: wortel.querySelector('[data-lf-laag]')
    };

    var geld = maakGeld(data.valuta, data.taal);

    // ---------- lijsten met keuzemogelijkheden ----------
    // De uitvoeringen staan niet apart in de gegevens; ze worden afgeleid uit de
    // varianten. Dat behoudt meteen de volgorde die in Shopify is ingesteld.
    var uitvoeringen = uniekeWaarden(idx.uitvoering);
    var houtsoorten = data.hout || [];
    var groepen = data.stofgroepen || [];

    // ---------- toestand ----------
    var keuze = {
      uitvoering: null,
      stofgroep: null,
      hout: null,
      stof: null
    };

    // Beginnen bij de eerste leverbare variant, zodat de pagina nooit opent op
    // een combinatie die niet besteld kan worden.
    var eerste = data.varianten.filter(function (v) { return v.beschikbaar; })[0] || data.varianten[0];
    keuze.uitvoering = waardeVan(eerste, idx.uitvoering);
    keuze.stofgroep = waardeVan(eerste, idx.stofgroep);
    keuze.hout = waardeVan(eerste, idx.hout);
    keuze.stof = eersteStof(keuze.stofgroep);

    tekenUitvoering();
    tekenHout();
    tekenGroepen();
    koppelGalerij();
    koppelLaag();
    volgKnop();
    werkBij();

    // ---------------------------------------------------------------- tekenen

    function tekenUitvoering() {
      if (!vak.uitvoering || idx.uitvoering < 0) return;
      vak.uitvoering.innerHTML = '';
      uitvoeringen.forEach(function (waarde) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-stoel-chip';
        knop.textContent = waarde;
        knop.setAttribute('aria-pressed', 'false');
        knop.dataset.waarde = waarde;
        knop.addEventListener('click', function () { kies('uitvoering', waarde); });
        vak.uitvoering.appendChild(knop);
      });
    }

    function tekenHout() {
      if (!vak.hout || idx.hout < 0) return;
      vak.hout.innerHTML = '';
      houtsoorten.forEach(function (hout) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-stoel-hout__item';
        knop.setAttribute('aria-pressed', 'false');
        knop.dataset.waarde = hout.waarde;

        var staal = document.createElement('span');
        staal.className = 'lf-stoel-hout__staal';
        staal.appendChild(staalInhoud(hout, 'lf-stoel-hout__vlak'));
        staal.appendChild(vinkje('lf-stoel-hout__vink'));

        var naam = document.createElement('span');
        naam.className = 'lf-stoel-hout__naam';
        naam.textContent = hout.label || hout.waarde;

        knop.appendChild(staal);
        knop.appendChild(naam);
        knop.addEventListener('click', function () { kies('hout', hout.waarde); });
        vak.hout.appendChild(knop);
      });
    }

    function tekenGroepen() {
      if (!vak.stofgroepen) return;
      vak.stofgroepen.innerHTML = '';
      groepen.forEach(function (groep) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-stoel-chip';
        knop.setAttribute('aria-pressed', 'false');
        knop.dataset.waarde = groep.code;
        knop.innerHTML = '<span>' + veilig(groep.code) + '</span><small data-prijs></small>';
        knop.addEventListener('click', function () { kies('stofgroep', groep.code); });
        vak.stofgroepen.appendChild(knop);
      });
    }

    // De stalen worden opnieuw getekend bij elke groepswissel. Dat is bij
    // hoogstens 25 tegels goedkoper en eenvoudiger dan tegels verbergen.
    function tekenStoffen() {
      if (!vak.stoffen) return;
      var lijst = stoffenVan(keuze.stofgroep);
      vak.stoffen.innerHTML = '';

      if (!lijst.length) {
        if (vak.stoffenLeeg) vak.stoffenLeeg.hidden = false;
        if (vak.stofkaart) vak.stofkaart.hidden = true;
        return;
      }
      if (vak.stoffenLeeg) vak.stoffenLeeg.hidden = true;

      lijst.forEach(function (stof) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-stoel-stof';
        knop.setAttribute('aria-pressed', 'false');
        knop.dataset.sleutel = sleutelVan(stof);
        knop.title = omschrijving(stof);
        knop.setAttribute('aria-label', omschrijving(stof));

        if (stof.foto) {
          var beeld = document.createElement('img');
          beeld.src = stof.foto;
          beeld.alt = '';
          beeld.loading = 'lazy';
          beeld.width = 160;
          beeld.height = 160;
          knop.appendChild(beeld);
        } else {
          var geen = document.createElement('span');
          geen.className = 'lf-stoel-stof__geen';
          geen.textContent = 'geen foto';
          knop.appendChild(geen);
        }
        knop.appendChild(vinkje('lf-stoel-stof__vink'));

        knop.addEventListener('click', function () { kies('stof', sleutelVan(stof)); });
        vak.stoffen.appendChild(knop);
      });
    }

    // ------------------------------------------------------------ keuze maken

    function kies(soort, waarde) {
      if (soort === 'stof') {
        keuze.stof = waarde;
        werkBij();
        return;
      }

      var gewenst = {
        uitvoering: keuze.uitvoering,
        stofgroep: keuze.stofgroep,
        hout: keuze.hout
      };
      gewenst[soort] = waarde;

      var variant = zoekVariant(gewenst);
      if (!variant || !variant.beschikbaar) {
        // Het zojuist aangeklikte kenmerk telt het zwaarst: liever een van de
        // andere keuzes verschuiven dan de klant op een dood spoor zetten.
        variant = besteVariantMet(soort, waarde, gewenst);
      }
      if (variant) {
        keuze.uitvoering = waardeVan(variant, idx.uitvoering);
        keuze.stofgroep = waardeVan(variant, idx.stofgroep);
        keuze.hout = waardeVan(variant, idx.hout);
      } else {
        keuze[soort] = waarde;
      }

      if (!stoffenVan(keuze.stofgroep).some(function (s) { return sleutelVan(s) === keuze.stof; })) {
        keuze.stof = eersteStof(keuze.stofgroep);
      }
      werkBij();
    }

    // ------------------------------------------------------------- bijwerken

    function werkBij() {
      var variant = zoekVariant(keuze);

      tekenStoffen();
      merkAan(vak.uitvoering, '.lf-stoel-chip', keuze.uitvoering);
      merkAan(vak.hout, '.lf-stoel-hout__item', keuze.hout);
      merkAan(vak.stofgroepen, '.lf-stoel-chip', keuze.stofgroep);
      merkAan(vak.stoffen, '.lf-stoel-stof', keuze.stof, 'sleutel');

      werkGroepprijzen();
      werkStofkaart();
      werkCombi();
      werkTekst('uitvoering', keuze.uitvoering);
      werkTekst('hout', houtLabel(keuze.hout));
      werkTekst('stofgroep', keuze.stofgroep);
      werkTekst('aantal-stoffen', aantalTekst(stoffenVan(keuze.stofgroep).length));

      var groep = groepMet(keuze.stofgroep);
      if (vak.groeptoelichting) {
        vak.groeptoelichting.textContent = (groep && groep.toelichting) || '';
        vak.groeptoelichting.hidden = !(groep && groep.toelichting);
      }

      if (variant) {
        if (vak.variantId) vak.variantId.value = variant.id;
        var bedrag = geld(variant.prijs);
        if (vak.prijs) vak.prijs.textContent = bedrag;
        if (vak.totaal) vak.totaal.textContent = bedrag;
        if (vak.mobielTotaal) vak.mobielTotaal.textContent = bedrag;
        if (variant.beeld && vak.hoofdbeeld) zetHoofdbeeld(variant.beeld);
      }

      werkEigenschappen();
      werkSamenvatting(variant);

      var kanBesteld = !!(variant && variant.beschikbaar);
      if (vak.bestel) vak.bestel.disabled = !kanBesteld;
      wortel.querySelectorAll('[data-lf-mobiel] button').forEach(function (k) { k.disabled = !kanBesteld; });
      if (vak.melding) {
        if (!variant) {
          vak.melding.textContent = 'Deze combinatie bestaat niet. Kies een andere uitvoering, stofgroep of houtkleur.';
          vak.melding.hidden = false;
        } else if (!variant.beschikbaar) {
          vak.melding.textContent = 'Deze combinatie is tijdelijk niet te bestellen. Neem contact op voor de mogelijkheden.';
          vak.melding.hidden = false;
        } else {
          vak.melding.hidden = true;
        }
      }
    }

    // Per stofgroep de prijs tonen die hoort bij de huidige uitvoering en
    // houtkleur. Zo is in één oogopslag te zien wat een groep méér kost.
    function werkGroepprijzen() {
      if (!vak.stofgroepen) return;
      vak.stofgroepen.querySelectorAll('.lf-stoel-chip').forEach(function (knop) {
        var variant = zoekVariant({
          uitvoering: keuze.uitvoering,
          stofgroep: knop.dataset.waarde,
          hout: keuze.hout
        });
        // Bestaat de combinatie met de huidige uitvoering niet, dan toch de
        // prijs van die groep tonen: de klant mag hem kiezen, waarna de
        // uitvoering meeschuift naar een combinatie die wél bestaat.
        if (!variant) variant = besteVariantMet('stofgroep', knop.dataset.waarde, keuze);

        var plek = knop.querySelector('[data-prijs]');
        if (plek) plek.textContent = variant ? geld(variant.prijs) : '';

        // Doorgestreept alleen als er van deze groep helemaal niets leverbaar is.
        knop.dataset.uit = variant && variant.beschikbaar ? 'false' : 'true';
      });
    }

    function werkStofkaart() {
      if (!vak.stofkaart) return;
      var stof = huidigeStof();
      if (!stof) { vak.stofkaart.hidden = true; return; }
      vak.stofkaart.hidden = false;

      var beeld = vak.stofkaart.querySelector('[data-lf-stofkaart-beeld]');
      if (beeld) beeld.innerHTML = stof.foto ? '<img src="' + veilig(stof.foto) + '" alt="" width="152" height="152">' : '';

      zetTekst('[data-lf-stofkaart-collectie]', stof.collectie || stof.uitstraling || '');
      zetTekst('[data-lf-stofkaart-naam]', stof.naam);
      zetTekst('[data-lf-stofkaart-meta]', metaRegel(stof));

      function zetTekst(kies, tekst) {
        var el = vak.stofkaart.querySelector(kies);
        if (el) el.textContent = tekst;
      }
    }

    function werkCombi() {
      var stof = huidigeStof();
      var hout = houtMet(keuze.hout);

      zetStaal('[data-lf-combi-stof-staal]', stof && stof.foto, null);
      zetTekstIn('[data-lf-combi-stof-naam]', stof ? stof.naam : '—');
      if (hout) {
        zetStaal('[data-lf-combi-hout-staal]', hout.foto, hout.terugval);
        zetTekstIn('[data-lf-combi-hout-naam]', hout.label || hout.waarde);
      }

      function zetStaal(kies, url, kleur) {
        var el = wortel.querySelector(kies);
        if (!el) return;
        if (url) {
          el.innerHTML = '<img src="' + veilig(url) + '" alt="" width="88" height="88">';
        } else if (kleur) {
          el.innerHTML = '';
          el.style.background = kleur;
        } else {
          el.innerHTML = '';
        }
      }
      function zetTekstIn(kies, tekst) {
        var el = wortel.querySelector(kies);
        if (el) el.textContent = tekst;
      }
    }

    function werkTekst(soort, tekst) {
      var el = wortel.querySelector('[data-lf-gekozen="' + soort + '"]');
      if (el) el.textContent = tekst || '';
    }

    function werkEigenschappen() {
      var stof = huidigeStof();
      var naam = wortel.querySelector('[data-lf-eigenschap="stof"]');
      var code = wortel.querySelector('[data-lf-eigenschap="stofcode"]');
      if (naam) naam.value = stof ? stof.naam : '';
      if (code) code.value = stof ? (stof.code || '') : '';
      // Een lege eigenschap zou als lege regel op de orderbevestiging komen.
      if (naam) naam.disabled = !stof;
      if (code) code.disabled = !(stof && stof.code);
    }

    function werkSamenvatting(variant) {
      if (!vak.samenvatting) return;
      var stof = huidigeStof();
      var hout = houtMet(keuze.hout);
      var regels = [];

      if (idx.uitvoering >= 0 && keuze.uitvoering) regels.push(['Uitvoering', keuze.uitvoering]);
      regels.push(['Stofgroep', keuze.stofgroep || '—']);
      regels.push(['Stof', stof ? omschrijving(stof) : 'nog niet gekozen']);
      if (hout) regels.push(['Hout', hout.label || hout.waarde]);
      // Bewust geen artikelnummer: de leveranciers-SKU
      // ("PP-EETKAMERSTOEL-BAZUL-PBAZUL10SN-LSA-N24") is voor een klant ruis.
      // Hij gaat via de variant gewoon mee met de bestelling.

      vak.samenvatting.innerHTML = regels.map(function (regel) {
        return '<dt>' + veilig(regel[0]) + '</dt><dd>' + veilig(regel[1]) + '</dd>';
      }).join('');
    }

    // ---------------------------------------------------------------- galerij

    function koppelGalerij() {
      if (!vak.strip) return;
      vak.strip.querySelectorAll('[data-lf-thumb]').forEach(function (knop) {
        knop.addEventListener('click', function () { zetHoofdbeeld(knop.dataset.lfThumb); });
      });
    }

    function zetHoofdbeeld(url) {
      if (!vak.hoofdbeeld || !url) return;
      vak.hoofdbeeld.src = url;
      if (vak.strip) {
        vak.strip.querySelectorAll('[data-lf-thumb]').forEach(function (knop) {
          knop.setAttribute('aria-current', knop.dataset.lfThumb === url ? 'true' : 'false');
        });
      }
    }

    // ------------------------------------------------------------ vergroting

    function koppelLaag() {
      if (!vak.laag) return;
      var opener = wortel.querySelector('[data-lf-stofkaart-loep]');
      if (opener) opener.addEventListener('click', openLaag);

      vak.laag.addEventListener('click', function (gebeurtenis) {
        if (gebeurtenis.target === vak.laag) sluitLaag();
      });
      var sluit = vak.laag.querySelector('[data-lf-laag-sluit]');
      if (sluit) sluit.addEventListener('click', sluitLaag);
      // Escape sluit; Tab blijft binnen de laag zolang hij open is. aria-modal
      // vertelt een schermlezer dat de rest van de pagina niet bestaat, dus
      // het toetsenbord moet zich daar ook aan houden.
      document.addEventListener('keydown', function (gebeurtenis) {
        if (vak.laag.hidden) return;
        if (gebeurtenis.key === 'Escape') { sluitLaag(); return; }
        if (gebeurtenis.key !== 'Tab') return;
        var focusbaar = vak.laag.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
        if (!focusbaar.length) return;
        var eerste = focusbaar[0];
        var laatste = focusbaar[focusbaar.length - 1];
        if (!vak.laag.contains(document.activeElement)) {
          gebeurtenis.preventDefault();
          eerste.focus();
        } else if (gebeurtenis.shiftKey && document.activeElement === eerste) {
          gebeurtenis.preventDefault();
          laatste.focus();
        } else if (!gebeurtenis.shiftKey && document.activeElement === laatste) {
          gebeurtenis.preventDefault();
          eerste.focus();
        }
      });
    }

    function openLaag() {
      var stof = huidigeStof();
      if (!stof || !vak.laag) return;

      var beeld = vak.laag.querySelector('[data-lf-laag-beeld]');
      if (beeld) beeld.innerHTML = stof.foto ? '<img src="' + veilig(stof.foto) + '" alt="' + veilig(omschrijving(stof)) + '">' : '';

      var collectie = vak.laag.querySelector('[data-lf-laag-collectie]');
      if (collectie) collectie.textContent = stof.collectie || '';
      var naam = vak.laag.querySelector('[data-lf-laag-naam]');
      if (naam) naam.textContent = stof.naam;

      var gegevens = vak.laag.querySelector('[data-lf-laag-gegevens]');
      if (gegevens) {
        var rijen = [
          ['Kleurcode', stof.code],
          ['Kleur', stof.kleurnaam],
          ['Kleurfamilie', stof.kleurfamilie],
          ['Uitstraling', stof.uitstraling],
          ['Samenstelling', stof.materiaal],
          ['Slijtvastheid', stof.martindale],
          ['Onderhoud', stof.onderhoud],
          ['Stofgroep', keuze.stofgroep]
        ].filter(function (rij) { return rij[1]; });
        gegevens.innerHTML = rijen.map(function (rij) {
          return '<dt>' + veilig(rij[0]) + '</dt><dd>' + veilig(rij[1]) + '</dd>';
        }).join('');
      }

      vak.laag.hidden = false;
      var sluit = vak.laag.querySelector('[data-lf-laag-sluit]');
      if (sluit) sluit.focus();
    }

    function sluitLaag() {
      if (!vak.laag) return;
      vak.laag.hidden = true;
      var opener = wortel.querySelector('[data-lf-stofkaart-loep]');
      if (opener) opener.focus();
    }

    // ------------------------------------------------------------ mobiele balk

    // De balk verschijnt zodra de echte bestelknop uit beeld is. Zonder die
    // controle staat hij ook onder de knop zelf, en dat leest als twee knoppen.
    function volgKnop() {
      if (!vak.mobiel || !vak.bestel || !('IntersectionObserver' in window)) return;
      var kijker = new IntersectionObserver(function (waarnemingen) {
        waarnemingen.forEach(function (waarneming) {
          vak.mobiel.dataset.zichtbaar = waarneming.isIntersecting ? 'false' : 'true';
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      kijker.observe(vak.bestel);
    }

    // ------------------------------------------------------------- hulpstukken

    function waardeVan(variant, index) {
      if (index == null || index < 0) return null;
      return variant.waarden[index];
    }

    function uniekeWaarden(index) {
      if (index == null || index < 0) return [];
      var gezien = [];
      data.varianten.forEach(function (variant) {
        var waarde = variant.waarden[index];
        if (waarde && gezien.indexOf(waarde) === -1) gezien.push(waarde);
      });
      return gezien;
    }

    function zoekVariant(gewenst) {
      return data.varianten.filter(function (variant) {
        if (idx.uitvoering >= 0 && gewenst.uitvoering && variant.waarden[idx.uitvoering] !== gewenst.uitvoering) return false;
        if (idx.stofgroep >= 0 && gewenst.stofgroep && variant.waarden[idx.stofgroep] !== gewenst.stofgroep) return false;
        if (idx.hout >= 0 && gewenst.hout && variant.waarden[idx.hout] !== gewenst.hout) return false;
        return true;
      })[0] || null;
    }

    // Zoekt de leverbare variant die het aangeklikte kenmerk vasthoudt en verder
    // zo veel mogelijk op de huidige keuze lijkt.
    function besteVariantMet(soort, waarde, gewenst) {
      var index = idx[soort];
      if (index == null || index < 0) return null;

      var kandidaten = data.varianten.filter(function (variant) {
        return variant.waarden[index] === waarde && variant.beschikbaar;
      });
      if (!kandidaten.length) return null;

      kandidaten.sort(function (a, b) { return punten(b) - punten(a); });
      return kandidaten[0];

      function punten(variant) {
        var som = 0;
        ['uitvoering', 'stofgroep', 'hout'].forEach(function (naam) {
          var i = idx[naam];
          if (i != null && i >= 0 && gewenst[naam] && variant.waarden[i] === gewenst[naam]) som++;
        });
        return som;
      }
    }

    function groepMet(code) {
      return groepen.filter(function (groep) { return groep.code === code; })[0] || null;
    }

    function stoffenVan(code) {
      var groep = groepMet(code);
      return (groep && groep.stoffen) || [];
    }

    function eersteStof(code) {
      var lijst = stoffenVan(code);
      return lijst.length ? sleutelVan(lijst[0]) : null;
    }

    function huidigeStof() {
      return stoffenVan(keuze.stofgroep).filter(function (stof) {
        return sleutelVan(stof) === keuze.stof;
      })[0] || null;
    }

    function houtMet(waarde) {
      return houtsoorten.filter(function (hout) { return hout.waarde === waarde; })[0] || null;
    }

    function houtLabel(waarde) {
      var hout = houtMet(waarde);
      return hout ? (hout.label || hout.waarde) : (waarde || '');
    }

    // Kleurcodes zijn niet overal uniek (er staan dubbelen in de stoffenlijst),
    // dus de sleutel is code + naam.
    function sleutelVan(stof) {
      return (stof.code || '') + '|' + stof.naam;
    }

    function omschrijving(stof) {
      return stof.code ? stof.naam + ' (' + stof.code + ')' : stof.naam;
    }

    function metaRegel(stof) {
      return [stof.kleurfamilie, stof.uitstraling, stof.code ? 'code ' + stof.code : '']
        .filter(Boolean).join(' · ');
    }

    function aantalTekst(aantal) {
      if (!aantal) return '';
      return aantal === 1 ? '1 kleur' : aantal + ' kleuren';
    }

    function merkAan(houder, kiezer, waarde, veld) {
      if (!houder) return;
      houder.querySelectorAll(kiezer).forEach(function (knop) {
        var eigen = veld === 'sleutel' ? knop.dataset.sleutel : knop.dataset.waarde;
        knop.setAttribute('aria-pressed', eigen === waarde ? 'true' : 'false');
      });
    }

    function staalInhoud(hout, klasseVoorVlak) {
      if (hout.foto) {
        var beeld = document.createElement('img');
        beeld.src = hout.foto;
        beeld.alt = '';
        beeld.loading = 'lazy';
        beeld.width = 160;
        beeld.height = 160;
        return beeld;
      }
      var vlak = document.createElement('span');
      vlak.className = klasseVoorVlak;
      vlak.style.background = hout.terugval || '#C9A97A';
      return vlak;
    }

    function vinkje(klasse) {
      var houder = document.createElement('span');
      houder.className = klasse;
      houder.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
      return houder;
    }

    function veilig(tekst) {
      return String(tekst == null ? '' : tekst)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  }

  // Bedragen komen in centen binnen. Intl doet de opmaak, met een simpele
  // terugval voor browsers waar de valuta niet bekend is.
  function maakGeld(valuta, taal) {
    var opmaak;
    try {
      opmaak = new Intl.NumberFormat(taal || 'nl-NL', {
        style: 'currency',
        currency: valuta || 'EUR',
        minimumFractionDigits: 2
      });
    } catch (fout) {
      opmaak = null;
    }
    return function (centen) {
      var bedrag = (centen || 0) / 100;
      return opmaak ? opmaak.format(bedrag) : '€ ' + bedrag.toFixed(2);
    };
  }
})();
